import { WorkOrder } from "@myapp/contract";
import { formatDateDDMMYYYY } from "../../../../shared/helpers/date";
import {
  EMPTY_IMMOTION_AUFTRAG_FIELDS,
  type ImmotionAuftragFields,
} from "./immotionAuftrag.types";

const toText = (value: string | number | null | undefined) => {
  if (value === null || value === undefined) {
    return "";
  }

  return String(value);
};

export const mapWorkOrderToImmotionAuftragFields = (
  workOrder?: WorkOrder,
): ImmotionAuftragFields => {
  if (!workOrder) {
    return EMPTY_IMMOTION_AUFTRAG_FIELDS;
  }

  const external = workOrder.external;
  const wirtschaftseinheitParts = [toText(external.ve), external.veAdresse ?? ""].filter(Boolean);
  const mieterParts = [
    external.mieter.name,
    external.mieter.telefon ? `Tel: ${external.mieter.telefon}` : null,
    external.mieter.email ? `E-Mail: ${external.mieter.email}` : null,
  ].filter(Boolean);
  return {
    schadensdatum: external.auftragsdatum ? formatDateDDMMYYYY(external.auftragsdatum) : "",
    mieter: mieterParts.join("\n"),
    wirtschaftseinheit: wirtschaftseinheitParts.join(" - "),
    hauseingang: toText(external.hauseingang),
    wohnung: toText(external.wohnung),
    gewerk: toText(external.gewerkeText),
    leistung: toText(external.leistungText),
    schadensbeschreibung: toText(external.individuellerText),
    erfasser: toText(external.erfasserName),
    isWohnungsmodernisierung: external.isWohnungsmodernisierung,
  };
};
